import script from "./UPCOMING_TIME_OFF_NOTIFICATION.vue?vue&type=script&setup=true&lang=ts"
export * from "./UPCOMING_TIME_OFF_NOTIFICATION.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__